import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Nav from './Nav';
import {Switch, Route, Redirect} from 'react-router-dom';
// import AdminUsers from 'components/users/AdminUsersList.js';
import Users from 'sections/users';
import Procedures from 'sections/procedures';
import Operations from 'sections/operations';
import Channels from 'sections/channels';
import Tasks from 'sections/tasks';
import Tags from 'sections/tags';
import Items from 'sections/procedureItems';
import Templates from 'sections/procedureTemplates';
import {OrganizationCtxProvider} from 'components/dataProviders/organization';
import {UsersCtxProvider} from 'components/dataProviders/users';
import { TagsCtxProvider } from 'components/dataProviders/tags';
import { CallInfoProvider } from 'components/dataProviders/callInfo';
import { OperationsCtxProvider } from 'components/dataProviders/operations';
import { LocationsCtxProvider } from 'components/dataProviders/arLocations';
import { AnchorsCtxProvider } from 'components/dataProviders/arAnchors';
import VideocallInterface from 'components/videocall/VideoCallInterface';
import { ProcedureItemsCtxProvider } from 'components/dataProviders/procedureItems';
import {FileViewerCtxProvider} from 'components/DialogsContext';
import ApiErrorDialog from 'components/ApiErrorDialog';

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  menuButton: {
    marginRight: 36,
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9) + 1,
    },
  },
  content: {
    flexGrow: 1,
    // position: 'fixed'
    // height: '100%'
  },
}));

function AllDataProviders(props)
{
  return <>
    <OrganizationCtxProvider>
    <UsersCtxProvider>
    <TagsCtxProvider>
    <OperationsCtxProvider>
    <CallInfoProvider>
    <LocationsCtxProvider>
    <AnchorsCtxProvider>
    <ProcedureItemsCtxProvider>
    <FileViewerCtxProvider>
      {props.children}
    </FileViewerCtxProvider>
    </ProcedureItemsCtxProvider>
    </AnchorsCtxProvider>
    </LocationsCtxProvider>
    </CallInfoProvider>
    </OperationsCtxProvider>
    </TagsCtxProvider>
    </UsersCtxProvider>
    </OrganizationCtxProvider>
  </>
}

export default function MiniDrawer() {
  const classes = useStyles();

  return (
    <AllDataProviders>
    <div className={classes.root}>
      <VideocallInterface />
      <ApiErrorDialog />
      <Nav width={drawerWidth}/>
      <main className={classes.content}>
        <Switch>
          <Route path="/" exact>
            <Redirect to="/operations" />
          </Route>
            <Route path="/operations">
          <Operations />
          </Route>
          <Route path="/channels">
          <Channels />
          </Route>
            <Route path="/procedures">
          <Procedures />
          </Route>
            <Route path="/tasks">
          <Tasks />
          </Route>
            <Route path="/users">
          <Users />
          </Route>
            <Route path="/tags">
          <Tags />
          </Route>
            <Route path="/items">
          <Items />
          </Route>
            <Route path="/templates">
          <Templates />
          </Route>
        </Switch>
      </main>
    </div>
    </AllDataProviders>
  );
}
